import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, SetCartStatus } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import cloneDeep from "lodash/cloneDeep";

addToChainAfter(chain, SetCartStatus, props => {
    const state = props.getState();
    const CustomState = (props.getState() as any).KGPState.CheckoutReview;

    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    if (!cart) {
        throw new Error("There was no current cart and we are trying to place the current cart as an order.");
    }

    const {
        SpecialDeliveryInstructionList,
        accountNumber,
        approvalNotes,
        workOrder,
        releaseNumber,
        packingListNotesList,
        customerReference1,
        customerReference2,
        customerReference3,
        customerReference4,
    } = CustomState;

    props.cartToUpdate = {
        ...cloneDeep(props.cartToUpdate),
        // Adapty Custom Code Start
        notes: approvalNotes,
        properties: {
            shippingCollectAccountNumber: accountNumber,
            userSelectedSpecialDeliveryInstruction: SpecialDeliveryInstructionList as string,
            workOrderNumber: workOrder,
            releaseNumber,
            packingListAndInstructions: packingListNotesList,

            customerOrderRefSelectedValue1: customerReference1,
            customerOrderRefSelectedValue2: customerReference2,
            customerOrderRefSelectedValue3: customerReference3,
            customerOrderRefSelectedValue4: customerReference4,
        },
        // Adapty Custom Code ENd
    };
});
